import React from 'react';
import { Box, Typography, styled } from '@mui/material';
import MiaChat from '../../sharedComponents/MiaChat';

const ContentWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
}));

export const AnalyzePage: React.FC = () => {
  return (
    // <ContentWrapper>
      <MiaChat interfaceType="analyze" />
    // </ContentWrapper>
  );
};


